import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild } from '@angular/core';
import { noop } from 'rxjs';
export interface RadioEventArgs {
  value: any;
  radio: RadioButtonComponent;
}

@Component({
  selector: 'mpro-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {

  @Input() public label: string | undefined
  @Input() public value: any;
  @Input() public checked = false
  @Input() dark: boolean = false
  @Output() public readonly change: EventEmitter<RadioEventArgs> = new EventEmitter<RadioEventArgs>();

  @ViewChild('radio', { static: true })
  public nativeRadio: ElementRef;

  @Input()
  public get disabled(): boolean {
      return this._disabled;
  }
  public set disabled(value: boolean) {
      this._disabled = (value as any === '') || value;
  }

  @HostListener('click')
  public _clicked() {
    if (!this.disabled) {
      this.select()
    }
  }

  public select() {
    this.nativeRadio.nativeElement.focus();
    if(!this.checked) {
        this.checked = true;
        this.change.emit({ value: this.value, radio: this });
        this._onChangeCallback(this.value);
    }
}

  private _disabled = false;

  private _onChangeCallback: (_: any) => void = noop;

  public registerOnChange(fn: (_: any) => void) {
    this._onChangeCallback = fn;
}
}

